<template>
    <div>
        <profile-info-module profileSettingsRoute="/admin/profile/settings"></profile-info-module>
    </div>
</template>

<script>import ProfileInfoModule from '../partials/ProfileInfoModule';
    export default {
        components: {
            'profile-info-module': ProfileInfoModule,
        },
        data() {
            return {

            }
        }
    }</script>

<style lang="scss" scoped>
</style>
